import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import { NotebookPen, Check, Clock } from "lucide-react";

const money = (v) => `₺${Number(v || 0).toFixed(2)}`;
const fmt = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export default function Veresiye() {
  const [data, setData] = useState({ credits: [], openTotal: 0 });
  const load = () => api.get("/credits").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const settle = async (id) => { try { await api.post(`/credits/${id}/settle`); toast.success("Veresiye tahsil edildi"); load(); } catch (e) { toast.error(errMsg(e)); } };

  const open = data.credits.filter((c) => c.status === "open");
  const settled = data.credits.filter((c) => c.status === "settled");

  return (
    <div>
      <div className="flex items-center gap-3 mb-1">
        <NotebookPen className="text-[#D4AF37]" size={28} />
        <h1 className="font-serif text-3xl sm:text-4xl text-white">Veresiye Defteri</h1>
      </div>
      <p className="text-zinc-400 text-sm mb-6">Açık veresiye kayıtları ve tahsilat</p>

      <div className="card-lux p-5 mb-6 flex items-center justify-between" data-testid="veresiye-total">
        <span className="text-zinc-300">Toplam Açık Veresiye</span>
        <span className="font-mono text-2xl text-amber-400">{money(data.openTotal)}</span>
      </div>

      <h2 className="font-serif text-xl text-white mb-3">Açık ({open.length})</h2>
      <div className="space-y-3 mb-8">
        {open.length === 0 && <p className="text-zinc-600 text-sm">Açık veresiye yok 🎉</p>}
        {open.map((c) => (
          <div key={c.id} className="card-lux p-4 flex items-center justify-between" data-testid={`credit-${c.id}`}>
            <div>
              <div className="font-serif text-lg text-white">{c.customerName}</div>
              <div className="text-xs text-zinc-500 flex items-center gap-2 mt-0.5"><Clock size={12} />{fmt(c.createdAt)} • {c.tableName}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-mono text-lg text-amber-400">{money(c.amount)}</span>
              <button onClick={() => settle(c.id)} className="btn-gold px-4 py-2 rounded-lg text-sm flex items-center gap-1.5" data-testid={`settle-${c.id}`}><Check size={15} />Tahsil Et</button>
            </div>
          </div>
        ))}
      </div>

      <h2 className="font-serif text-xl text-white mb-3">Tahsil Edilenler ({settled.length})</h2>
      <div className="space-y-2">
        {settled.map((c) => (
          <div key={c.id} className="flex items-center justify-between bg-[#18181C] rounded-xl px-4 py-2.5 opacity-70" data-testid={`settled-${c.id}`}>
            <div><span className="text-white text-sm">{c.customerName}</span> <span className="text-xs text-zinc-500">• {c.tableName}</span></div>
            <span className="font-mono text-emerald-400 text-sm flex items-center gap-1"><Check size={13} />{money(c.amount)}</span>
          </div>
        ))}
        {settled.length === 0 && <p className="text-zinc-600 text-sm">—</p>}
      </div>
    </div>
  );
}
